import { COLORS } from '../theme';

export const getColorForCompanyStatus = (status: string | null, companyId: string | null) => {
  // Draft accounts have no status or companyId
  if (!status && !companyId) {
    return COLORS.lightGray;
  }

  // Matched accounts and Creditsafe results have status
  if (status?.toLowerCase() === 'active') {
    return COLORS.lightGreen;
  }
  return COLORS.lightYellow;
};

export const getLabelForCompanyStatus = (params: {
  status: string | null;
  companyId: string | null;
  statusDescription: string | null;
  activeLabel: string;
  draftLabel: string;
  unknownLabel: string;
}) => {
  if (!params.status && !params.companyId) {
    return params.draftLabel;
  }
  return params.status?.toLowerCase() === 'active' ? params.activeLabel : params.statusDescription ?? params.unknownLabel;
};
